import { useEffect, useMemo } from "react"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"

import type { Tower } from "types/towers.types"

import { BodyContainer } from "widgets/styled/containers"
import TowerDashboard from "widgets/towers/TowerDashboard"
import { getTowerSegmentsTabPlotDefs } from "helpers/config/dashboards"
import { getTowerSegments, hasTowerSegments } from "helpers/utils/towerHealth"

const TowerSegments = () => {
  const navigate = useNavigate()
  const { orgId, id } = useParams()
  const { tower, towerFetching } = useOutletContext<{
    tower: Tower
    towerFetching: boolean
  }>()

  const segments = useMemo(() => getTowerSegments(tower.settings), [tower.settings])
  const hasSegmentsTab = hasTowerSegments(tower)

  useEffect(() => {
    if (!hasSegmentsTab) {
      navigate(`/orgs/${orgId}/towers/${id}`, { replace: true })
    }
  }, [hasSegmentsTab, navigate, orgId, id])

  const config = useMemo(
    () => ({
      type: "towerSegmentsTab" as const,
      plotDefs: getTowerSegmentsTabPlotDefs(segments),
    }),
    [segments],
  )

  if (!hasSegmentsTab) {
    return null
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <TowerDashboard tower={tower} towerFetching={towerFetching} config={config} />
    </BodyContainer>
  )
}

export default TowerSegments
